import React from 'react';
import { Modal, SparkModalPortal, Text } from '@spark';

/**
 * "Continue without a benchmark?" confirmation (Figma 3198-8961), shown on
 * Next when a dataset was picked without a benchmark.
 */
const ContinueWithoutBenchmarkModal = ({ open, onCancel, onContinue }) => {
    if (!open) return null;
    return (
        <SparkModalPortal
            open
            onClose={onCancel}
            size="text"
            className="cw-dc-benchmark-modal-portal"
        >
            <Modal
                title="Continue without a benchmark?"
                feedbackType="warning"
                showSubtitle={false}
                showScrollBar={false}
                showOverlay={false}
                fixedHeight={false}
                primaryLabel="Continue Anyway"
                primaryDisableWhenReadOnly
                tertiaryLabel="Cancel"
                onPrimaryClick={onContinue}
                onTertiaryClick={onCancel}
                onCloseClick={onCancel}
                className="cw-dc-benchmark-modal"
            >
                <Text variant="base-regular" color="secondary" as="p">
                Upload a verified benchmark for reliable evaluation. Otherwise, 10% of your dataset will be used automatically, and inaccuracies may affect results.
                </Text>
            </Modal>
        </SparkModalPortal>
    );
};

export default ContinueWithoutBenchmarkModal;
